import {useEffect, useState} from "react";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {PeriodService} from "../../serverService/periodService/PeriodService";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {css} from "@emotion/css";
import {
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoChipTypes,
    RaikoCustomSimpleChip, RaikoCustomTable, RaikoFlexAlignEnd,
    RaikoGridOneColumn, RaikoGridTwoColumn,
    showServerErrorMessage, showSuccessMessage,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoCardInfoTypeOneStatusTypes
} from "@moeindal/base-raiko-panel-components";
const ShowResidenceInformation = (
    {
        handleBackPage,
        residenceInfo,
        periodId,
        requestId,
        reserveId = -1,
        handleCloseDialog
    }) => {

    let page = 0
    let size = 15

    const service = new PeriodService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [isLoading, setIsLoading] = useState(false)
    const [residenceInfoList, setResidenceList] = useState([]);

    useEffect(() => {
        if (residenceInfo) {
            getDataFromServer()
        }
    }, [residenceInfo])

    function getDataFromServer() {
        setIsLoading(true)

        let request

        if (reserveId >= 0) {
            request = service.getResidenceDetailByReserve(reserveId, residenceInfo.id)
        } else {
            request = service.getResidenceDetailByRequest(requestId, residenceInfo.id)
        }

        request.then(response => {
            setResidenceList([])
            response.map((item, index) => {
                const freeMen = item.freeMen - item.numberOfMen
                const freeWomen = item.freeWomen - item.numberOfWomen


                setResidenceList(prevState => [

                    ...prevState, {
                        "date": convertUniversalDateToPersianDate(item.date),
                        "menCapacity": item.menCapacity,
                        "womenCapacity": item.womenCapacity,
                        "totalCapacity": item.totalCapacity,
                        "numberOfWomen": item.numberOfWomen,
                        "numberOfMen": item.numberOfMen,
                        "reservedMen": item.reservedMen,
                        "reservedWomen": item.reservedWomen,
                        "reserved": item.reserved,
                        "freeMen": item.freeMen,
                        "freeWomen": item.freeWomen,
                        "free": item.free,
                        state: item.freeWomen >= item.numberOfWomen && item.freeMen >= item.numberOfMen ?
                            <RaikoCustomSimpleChip title={"آزاد"} type={RaikoChipTypes.success}/> :
                            <RaikoCustomSimpleChip title={"تکمیل شده"} type={RaikoChipTypes.error}/>,
                        /*afterMen: freeMen >= 0 ?
                            <RaikoCustomSimpleChip title={`${freeMen}`} type={raikoChipTypes.success}/> :
                            <RaikoCustomSimpleChip title={`${freeMen}`} type={raikoChipTypes.error}/>,
                        afterWomen: freeWomen >= 0 ?
                            <RaikoCustomSimpleChip title={`${freeWomen}`} type={raikoChipTypes.success}/> :
                            <RaikoCustomSimpleChip title={`${freeWomen}`} type={raikoChipTypes.error}/>,*/
                    }
                ])


            })
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setIsLoading(false)
        })
    }

    function handleRegisterRequest() {
        loading.show()
        let request

        if (reserveId >= 0) {
            request = service.changeHabitationRequest(residenceInfo.id, reserveId)
        } else {
            request = service.setHabitationRequest(residenceInfo.id, requestId)
        }

        request
            .then(response => {
                showSuccessMessage("مکان اسکان با موفقیت انتخاب شد!")
                handleCloseDialog()
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(ـ => {
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn>
            {/*<RaikoCustomTable*/}
            {/*    isLoading={isLoading}*/}
            {/*    data={residenceInfoList}*/}
            {/*    header={tableHeader}/>*/}
            <RaikoGridTwoColumn>
                {
                    residenceInfoList.map((item, index) => {
                        return <RaikoCardInfoTypeOne
                            key={index}
                            title={residenceInfo.title}
                            titleLabel={item.date}
                            status
                            statusText={item.freeWomen >= item.numberOfWomen && item.freeMen >= item.numberOfMen ?
                                "آزاد" : "تکمیل شده"}
                            statusType={item.freeWomen >= item.numberOfWomen && item.freeMen >= item.numberOfMen ?
                                RaikoCardInfoTypeOneStatusTypes.SUCCESS : RaikoCardInfoTypeOneStatusTypes.ERROR}
                            items={[
                                RaikoCardInfoTypeOneItemGenerator("ظرفیت کل", item.totalCapacity),
                                RaikoCardInfoTypeOneItemGenerator("ظرفیت آقایان", item.menCapacity),
                                RaikoCardInfoTypeOneItemGenerator("ظرفیت خانم", item.womenCapacity),
                                RaikoCardInfoTypeOneItemGenerator("رزو شده کل", item.reserved),
                                RaikoCardInfoTypeOneItemGenerator("رزو شده آقا", item.reservedMen),
                                RaikoCardInfoTypeOneItemGenerator("رزو شده خانم", item.reservedWomen),
                                RaikoCardInfoTypeOneItemGenerator("باقی مانده کل", item.free),
                                RaikoCardInfoTypeOneItemGenerator("باقی مانده آقا", item.freeWomen),
                                RaikoCardInfoTypeOneItemGenerator("باقی مانده خانم", item.freeMen),
                                RaikoCardInfoTypeOneItemGenerator("تعداد درخواست کل", item.numberOfMen + item.numberOfWomen),
                                RaikoCardInfoTypeOneItemGenerator("تعداد درخواست آقا", item.numberOfMen),
                                RaikoCardInfoTypeOneItemGenerator("تعداد درخواست خانم", item.numberOfWomen),

                            ]}
                        />
                    })
                }
            </RaikoGridTwoColumn>


            <RaikoFlexAlignEnd className={css`gap: .5rem;`}>
                <RaikoButtonSecondary label={"بازگشت"} onClick={handleBackPage}/>
                <RaikoButtonPrimary label={"ثبت"} onClick={handleRegisterRequest}/>

            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}
export default ShowResidenceInformation;

/*
    {
    "date": "2023-01-01",
    "menCapacity": 0,
    "womenCapacity": 0,
    "totalCapacity": 0,
    "numberOfWomen": 0,
    "numberOfMen": 0,
    "reservedMen": 0,
    "reservedWomen": 0,
    "reserved": 0,
    "freeMen": 0,
    "freeWomen": 0,
    "free": 0
  }


* */

const tableHeader = [
    {
        id: "date",
        label: "تاریخ",
    },
    {
        id: "menCapacity",
        label: "ظرفیت آقایان"
    },
    {
        id: "womenCapacity",
        label: "ظرفیت خانم"
    },
    {
        id: "totalCapacity",
        label: "ظرفیت کل",
    },
    {
        id: "reservedMen",
        label: "رزو شده آقا",
    },
    {
        id: "reservedWomen",
        label: "رزو شده خانم"
    },
    {
        id: "reserved",
        label: "رزو شده کل",
    },
    {
        id: "numberOfMen",
        label: "تعداد آقا درخواستی",
    },
    {
        id: "numberOfWomen",
        label: "تعداد خانم درخواستی"
    },
    {
        id: "freeMen",
        label: "باقی مانده آقا"
    }, {
        id: "freeWomen",
        label: "باقی مانده خانم"
    },
    {
        id: "free",
        label: "باقی مانده کل"
    },

    /*{
        id: "afterMen",
        label: "باقی مانده کسر آقا"
    },
    {
        id: "afterWomen",
        label: "باقی مانده کسر خانم"
    },*/
    {
        id: "state",
        label: "وضعیت"
    },
]